<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "commondescr",
      key: "id",
      url: {},
      id: "",
      typeId: "",
      items: [
        { label: "填写拒绝理由", type: "header" },
        {
          label: "拒绝理由",
          name: "rejectContent",
          value: "",
          type: "input",
          width: "400px",
        },
      ],
      forms: {},
    };
  },
  props: ["onCancel", "id"],
  created() {
    if (this.id) {
      this.id = this.id;
    }
  },
  created() {},
  methods: {
    handleSubmit() {
      let q = this.forms;
      q.meetingId = this.id;
      q.type = 6;
      this.$refs.form.validate((valid) => {
        this.sloading = true;
        $utils.api
          .load(`/admin/system/meeting/edit`, q, "POST")
          .then((res) => {
            this.sloading = false;
            if (res.status) {
              $utils.toast.success("成功");
              setTimeout(() => {
                this.$emit("onCancel");
                $utils.url.go(0);
              }, 1000);
            }
          })
          .catch((e) => {
            this.sloading = false;
            $utils.toast.error("保存异常" + e.message);
          });
      });
    },
  },
};
</script>
